export default {
  aiClientServiceRelationManager: () => import('@/pages/ai/rights/clientServiceRelation.vue'),
  clientServiceRelationManager: () => import('@/pages/ai/rights/clientServiceRelation.vue'),
  aiOrganizationManager: () => import('@/pages/ai/rights/organization.vue'),
  aiPointAccountManager: () => import('@/pages/ai/rights/pointAccount.vue'),
  aiPointBucketManager: () => import('@/pages/ai/rights/pointBucket.vue'),
  aiPointLedgerManager: () => import('@/pages/ai/rights/pointLedger.vue'),
  aiPointPackageManager: () => import('@/pages/ai/rights/pointPackage.vue'),
  aiSubscriptionPlanManager: () => import('@/pages/ai/rights/subscriptionPlan.vue'),
  aiSubscriptionManager: () => import('@/pages/ai/rights/subscription.vue'),
  aiSubscriptionOrderManager: () => import('@/pages/ai/rights/subscriptionOrder.vue'),
  aiSubscriptionSeatManager: () => import('@/pages/ai/rights/subscriptionSeat.vue')
}
